const initialState = () => {
    return {
        posCashDeskId: 1 // 
    }
}

export default initialState
